import { Tags } from 'lucide-react'
import { defineModule } from '@/shell/module-system'
import { VendorPricelistsPage } from './pages/VendorPricelistsPage'
import { VendorPriceSheetReviewPage } from './pages/VendorPriceSheetReviewPage'

/**
 * Vendor Pricelists — rebuilt 2026-05-28 on the canonical Open Orders
 * pattern: DataTable + moduleId column persistence + filter rail +
 * SearchInput + MetricStrip page header band. Sourced from
 * `product.supplierinfo` via `/api/vendor-pricelists` (NOT the legacy
 * Sprint 03 surface at `/api/pricelists/vendor`, which filtered the
 * wrong Odoo model and showed only 3 vendors).
 *
 * Row click → drawer with vendor metadata + EditableGrid for inline
 * editing of price / min_qty / lead time / incoterm / vendor SKU. Add /
 * delete supported. Backend write endpoints gate on admin + operations
 * (vendor pricing is procurement-sensitive).
 */
export default defineModule({
  id: 'vendor-pricelists',
  name: 'Vendor Pricelists',
  shortName: 'Vendor Prices',
  icon: Tags,
  navSection: 'purchasing',
  navOrder: 20,
  urlNamespace: '/vendor-pricelists',
  routes: [
    { path: '/', element: VendorPricelistsPage, label: 'Vendor Pricelists' },
    {
      path: '/$vendorId/imports/$intakeId',
      element: VendorPriceSheetReviewPage,
      label: 'Price sheet review',
    },
  ],
  permissions: ['admin', 'operations', 'operations_logistics', 'purchasing'],
  densityDefault: 'compact',
  filterRailDefault: 'collapsed',
  mobileStrategy: 'desktop-only',

  keyboardShortcut: 'g v',

  commandPaletteEntries: [
    {
      label: 'Go to Vendor Pricelists',
      keywords: [
        'pricelist',
        'pricelists',
        'vendor',
        'supplier',
        'cost',
        'purchasing',
        'supplierinfo',
      ],
      path: '/',
      group: 'modules',
      shortcut: 'g v',
    },
  ],

  deepLinkHandlers: [
    {
      entity: 'vendor',
      label: 'View vendor pricelist',
      buildPath: (vendorId) => `/?vendor=${vendorId}`,
    },
  ],

  consumesServices: ['odoo-search'],
})
